/**
 * Insurance Agencies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageExpensesComponent,
  AsyncAddExpenseComponent,
  AsyncModifyExpenseComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageExpensesComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddExpenseComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyExpenseComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
